import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { useApiClient } from '../lib/use-api-client.js';

/**
 * Shape returned by `GET /v1/me`. Mirrors the handler in
 * `apps/admin-console-api/src/handlers/me.ts`. Re-derive from
 * `@wf-coe/types` once the canonical schema lands there.
 */
export interface MeResponse {
  id: string;
  sub: string;
  roles: string[];
  name: string | null;
  email: string | null;
}

/**
 * TanStack Query hook for the calling user's identity. Disables itself
 * until {@link useApiClient} returns a non-undefined client (i.e. until
 * the user is signed in).
 */
export function useMeQuery(): UseQueryResult<MeResponse> {
  const api = useApiClient();
  return useQuery({
    queryKey: ['me'],
    queryFn: () => {
      if (!api) {
        throw new Error('useMeQuery: api client unavailable (no signed-in account)');
      }
      return api.get<MeResponse>('/v1/me');
    },
    enabled: api !== undefined,
  });
}
